import * as React from "react";
import { Grid, Stack, Link } from "@mui/material";
import OrganizationDetails from "./OrganizationDetails";
import OrganizationPlaceOfService from "./OrganizationPlaceOfService";
import OrganizationPermissions from "./OrganizationPermissions";
import BillingProvider from "./BillingProvider";

interface Props {
  organization: any;
  pencil_grey: string;
  handleEditingOn: any;
  placeOfServiceList: any[];
  placeOfService: any;
  setPlaceOfService: any;
  setSelectedOrganization: any;
}

const OrganizationShow: React.FC<Props> = ({
  pencil_grey,
  organization,
  handleEditingOn,
  placeOfServiceList,
  placeOfService,
  setPlaceOfService,
  setSelectedOrganization,
}) => {
  const [permitted, setPermitted] = React.useState<boolean>(false);

  return (
    <Grid
      item
      xs={6}
      className="panel-container"
      style={{ marginTop: "85px", backgroundColor: "transparent" }}
    >
      <Grid item xs={12} style={{ marginRight: "30px" }}>
        <Grid container className="panel-show-container">
          <Grid container className="panel-information-container">
            <Grid
              container
              direction="row"
              className="admin-header patient-info"
            >
              <Grid item xs={12} className="box-header">
                <Stack
                  direction={"row"}
                  justifyContent={"space-between"}
                  paddingX={3}
                  paddingY={1}
                  alignItems={"center"}
                  display={"flex"}
                >
                  <Grid item>
                    <p className="panel-header">Organization Information</p>
                  </Grid>
                  <span>
                    <Link
                      className="action-icon"
                      href="#"
                      onClick={handleEditingOn}
                    >
                      <img
                        src={pencil_grey}
                        width="35"
                        alt="Edit Organization"
                        className="action-icon-image"
                        style={{ width: "25px", maxHeight: "25px" }}
                      />
                      <p>Edit</p>
                    </Link>
                  </span>
                </Stack>
              </Grid>
            </Grid>
            <Grid
              container
              className="general-patient-info-container"
              style={{ display: "flex", rowGap: "12px" }}
            >
              <OrganizationDetails organization={organization} />
              <OrganizationPlaceOfService
                placeOfServiceList={placeOfServiceList}
                placeOfService={placeOfService}
                setPlaceOfService={setPlaceOfService}
                organizationId={organization?.id}
                setSelectedOrganization={setSelectedOrganization}
              />
              {permitted && (
                <BillingProvider
                  placeOfServiceList={placeOfServiceList}
                  organizationId={organization?.id}
                  billingProvider={organization?.billing_provider}
                  setSelectedOrganization={setSelectedOrganization}
                />
              )}
              <OrganizationPermissions
                organizationId={organization?.id}
                setPermitted={setPermitted}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OrganizationShow;
